// Form limits constants (matching backend LIMITS class)
export const LIMITS = {
  SHORT_TEXT_MIN_LEN_LOWER: 1,
  PARAGRAPH_MIN_LEN_LOWER: 1,
  SHORT_TEXT_MAX_LEN_UPPER: 500,
  PARAGRAPH_MAX_LEN_UPPER: 5000,
  MCQ_OPTIONS_UPPER: 20,
  DROPDOWN_OPTIONS_UPPER: 500,
  CHECKBOX_OPTIONS_UPPER: 20,
};

// Default configurations with limits applied
export const DEFAULT_CONFIGS = {
  SHORT_TEXT: {
    uiConfig: {},
    minLen: 1,
    maxLen: 100, // Can be up to 500
  },
  PARAGRAPH: {
    uiConfig: {},
    minLen: 1,
    maxLen: 1000, // Can be up to 5000
  },
  MULTIPLE_CHOICE: {
    uiConfig: {},
    options: [''],
    maxSelections: 1, // Always 1 for MCQ
    minSelections: 1, // Always 1 for MCQ
  },
  CHECKBOX: {
    uiConfig: {},
    options: [''],
    maxSelections: 1, // Will be set to number of options by default
    minSelections: 1, // Default min selection
  },
  DROPDOWN: {
    uiConfig: {},
    options: [''],
    // No selection limits for dropdown
  },
  STATEMENT: null,
};
